import { helper } from '@ember/component/helper';
import normalizeUrl from '../utils/normalize-url';

export default helper(function (positional /*, named*/) {
  let [url] = positional;

  return normalizeUrl(url);
});